import styled from 'styled-components';

/**
 * One row of recommendation cards that shrink together, never two-and-one. Each card gets an
 * equal column capped at 380px; below the mobile breakpoint they stack in one column.
 */
export const RecommendationCardGrid = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 380px);
  gap: 24px;
  justify-content: center;
  max-width: 1200px;
  width: 100%;

  @media (max-width: 768px) {
    grid-auto-flow: row;
    grid-auto-columns: auto;
    grid-template-columns: minmax(0, 1fr);
    max-width: 400px;
  }
`;
